import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showApiErrorToast, showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface EncounterPlace {
  place: string
  city?: string
  country?: string
  state?: string
  region?: string
}

interface UpdateCalendarEventData {
  id: string
  title?: string
  description?: string
  startDateTime?: string // ISO date string
  endDateTime?: string // ISO date string
  allDay?: boolean
  rrule?: string | null
  location?: EncounterPlace
  type?: 'private' | 'common' | 'all'
  participantAccountIds?: string[]
  hasReminder?: boolean
  descriptionAsReminder?: boolean
  isDone?: boolean
}

const updateCalendarEvent = async (data: UpdateCalendarEventData): Promise<void> => {
  const { id, ...updateData } = data
  await api.put(`/calendar-event/${id}`, updateData)
}

export const useUpdateCalendarEvent = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, UpdateCalendarEventData>({
    mutationFn: updateCalendarEvent,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.eventUpdated'))
      await queryClient.invalidateQueries({ queryKey: ['calendar-events'] })
      await queryClient.invalidateQueries({ queryKey: ['calendar-event', variables.id] })
    },
    onError: (error) => {
      showApiErrorToast(t, error)
    },
  })
}

